import cart from './cart'
export default `mutation setBillingAddressOnCart($input: SetBillingAddressOnCartInput) {
  setBillingAddressOnCart(input: $input) {
    cart { ${cart} }
   }
 }
`
